module.exports = __webpack_public_path__ + "img/list_Story_09.02b431d5.jpeg";